import _ from 'underscore';

class SelectOrganizationCtrl {
  constructor($state, $stateParams, organizationService, userPreferencesService, $timeout, venueService, authService, permissionService) {
    const vm = this;

    permissionService.clearPermissions();

    vm.selectOrgs = false;
    vm.organizations = organizationService.getCurrentOrganizations();
    vm.selectOrganization = _selectOrganization;
    vm.goToBilling = _goToBilling;
    vm.goToLogin = _goToLogin;
    vm.loading = true;

    venueService.clear();

    const selectedOrganizationId = userPreferencesService.getDefaultOrganization();

    let selectedOrganization = selectedOrganizationId ? _.findWhere(vm.organizations, {
      id: selectedOrganizationId
    }) : null;

    if (vm.organizations.length === 1) {
      selectedOrganization = vm.organizations[0];
    }

    if (selectedOrganization && $stateParams.autoSelect === 'true') {
      $timeout(() => {
        _setAndGoToOrganization(selectedOrganization);
      }, 100);
    } else {
      $timeout(() => {
        vm.loading = false;
      }, 100);
    }

    vm.selectOrgs = true;

    function _selectOrganization(organization, $event) {
      if (!organization) return;
      if (!organization.enabled) return;
      if ($event) $event.preventDefault();

      _setAndGoToOrganization(organization);
    }

    function _goToBilling(organization) {
      if (!organization) throw new Error('selectOrganizationCtrl - _setAndGoToOrganization() - organization is required');

      $state.go('app.organization.settings.billing', {
        organizationId: organization.id,
        accountLocked: true
      });
    }

    function _goToLogin() {
      authService.logout();

      $state.go('login');
    }

    function _setAndGoToOrganization(organization) {
      if (!organization) throw new Error('selectOrganizationCtrl - _setAndGoToOrganization() - organization is required');

      if (!organization.enabled) {
        vm.selectOrgs = true;
        return;
      }

      vm.loading = true;

      organizationService.setCurrentOrganization(organization);

      userPreferencesService.setDefaultOrganization(organization.id);

      venueService.getCurrentVenues()
        .then(() => {
          const venue = venueService.getCurrentVenue();

          if (!venue) {
            $state.go('noVenues');
          } else if (!organizationService.isCurrentOrganizationAPromoter()) {
            $state.go('app.organization.manage.reservations', {
              organizationId: organization.id,
              venueId: venue.id
            });
          } else {
            $state.go('app.organization.promoter.sales.reservations', {
              organizationId: organization.id,
              venueId: venue.id
            });
          }

        });
    }

    return null;
  }
}

SelectOrganizationCtrl.$inject = [
  '$state',
  '$stateParams',
  'organizationService',
  'userPreferencesService',
  '$timeout',
  'venueService',
  'authService',
  'permissionService'
];

export default SelectOrganizationCtrl;



// WEBPACK FOOTER //
// ./src/components/selectOrganization/selectOrganizationCtrl.js